import {useEffect} from "react";
import {reactDomRoot} from "@App/utils/react-dom-root";


/**
 * Hook that automatically scrolls the page to x:0, y:0 on component mount
 */
export const useScrollToTop = () => {
    useEffect(() => {
        /**
         * scroll to top on component mount
         * only scroll to top if app is not embedded
         */

        window.scrollTo(0, reactDomRoot.offsetTop - 70)
    }, []);
}
